<template>
<div class="EduExperience">
    <div class="input_box">
        <van-cell-group>
            <van-cell clickable :title="`就读时间`">
                <div class="job_time_div">
                    <p @click="toggleStarTime()">{{eduFormData.edubegintext === '' ? '开始时间' : eduFormData.edubegintext}}</p>
                    <p>—</p>
                    <p v-if="eduFormData.istoday" @click="toggleEndTime()">至今</p>
                    <p v-else @click="toggleEndTime()">{{eduFormData.eduendtext === '' ? '结束时间' : eduFormData.eduendtext}}</p>
                </div>
            </van-cell>
            <van-field v-model="eduFormData.eduname" label="学校名称" placeholder="最多20个字" maxlength="20" />
            <van-field v-model="eduFormData.majorname" label="专业名称" placeholder="最多10个字" maxlength="10" />
            <van-cell clickable :title="`学历`" @click="toggleEdu()">
                <div class="edulevel_div">
                    <p v-if="eduFormData.edulevel === ''" style="color: #999;">请选择</p>
                    <p v-else style="color: #333;">{{eduText(eduFormData.edulevel)}}</p>
                    <img :src="require('@/common/images/mtalentimgs/icon_right.png')" alt="">
                </div>
            </van-cell>
            <van-cell clickable :title="`证书照片`">
                <div class="upload_div">
                    <div class="certificate_img_box" v-for="(imgItem, i) in eduFormData.eduimageinfp" :key="i">
                        <img class="del_img" @click="delImg(i)" :src="require('@/common/images/talentsimg/del_icon.png')" alt="">
                        <img class="certificate_img" :src="imgItem.furl" alt="">
                    </div>
                    <van-uploader v-if="eduFormData.eduimageinfp.length < 5" :max-count="5" :after-read="afterRead" :before-read="imgBeforeRead" />
                </div>
            </van-cell>
        </van-cell-group>
    </div>
    <div class="select_pop_box">
        <van-action-sheet v-model="selectStarTimePop" close-on-click-action>
            <div class="content">
                <van-datetime-picker v-model="currentDate" @confirm="onConfirmStar" @cancel="onCancelStar" type="year-month" title="开始时间" :min-date="minDate" :max-date="maxDate" :formatter="formatter"/>
            </div>
        </van-action-sheet>
    </div>
    <div class="select_pop_box">
        <van-action-sheet v-model="selectEndTimePop" close-on-click-action>
            <div class="content">
                <van-datetime-picker v-model="currentDate2" @confirm="onConfirmEnd" @cancel="onCancelEnd" type="year-month" title="结束时间" :min-date="minDate" :max-date="maxDate" :formatter="formatter"/>
            </div>
        </van-action-sheet>
    </div>
    <div class="select_pop_box">
        <van-action-sheet v-model="selectEduPop" close-on-click-action>
            <div class="content">
                <van-picker title="学历" show-toolbar :columns="eduOptions" @confirm="onConfirmEdu" @cancel="onCancelEdu" />
            </div>
        </van-action-sheet>
    </div>
    <div class="bottom_btn_box">
        <div v-if="$route.query.innerid2" @click="delBtn" class="cancel_btn">删除</div>
        <div v-else @click="cancelBtn" class="cancel_btn">取消</div>
        <div @click="saveBtn" class="save_btn">保存</div>
    </div>
</div>
</template>

<script>
import {getResumeEduInfo, saveOrUpdateEduInfo, deleteRelatedInfo} from 'api/talentApi'
import {getUploadParam} from 'api/personalCenterApi'
import {Toast, Dialog} from 'vant'
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
import axios from 'axios'
export default {
    name: 'EduExperience',
    data() {
        return {
            minDate: new Date(1990, 0, 1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            currentDate: new Date(),
            currentDate2: new Date(),
            selectStarTimePop: false,
            selectEndTimePop: false,
            selectEduPop: false,
            eduOptions: ['本科', '硕士', '博士'],
            eduFormData: {
                innerid: '',
                resumeinnerid: '',
                eduname: '',
                majorname: '',
                edubegin: '',
                edubegintext: '',
                eduend: '',
                eduendtext: '',
                edulevel: '',
                eduimageinfp: [],
                istoday: false
            },
            uploadType: {
                catecode: '93',
                datatype: 'IMAGE'
            },
            fileOtherInfo: {
                keyid: '',
                vsource: 1,
                furl: ''
            }
        }
    },
    mounted() {
        $('html').scrollTop(0)
        if (this.$route.query.innerid) {
            this.eduFormData.resumeinnerid = this.$route.query.innerid
        }
        if (this.$route.query.innerid2) {
            this.findResumeEduInfo()
        }
    },
    methods: {
        convertDateFromString(dateString) {
            if (dateString) { 
                var tmpdateString=dateString.replace(/-/g,"/")
                var date = new Date(tmpdateString) 
                return date
            }
        },
        findResumeEduInfo() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid2
            }
            getResumeEduInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eduFormData.innerid = data.data.innerid
                    this.eduFormData.resumeinnerid = data.data.resumeinnerid
                    this.eduFormData.edubegin = data.data.edubegin
                    this.eduFormData.edubegintext = data.data.edubegin1
                    this.eduFormData.eduend = data.data.eduend
                    this.eduFormData.eduendtext = data.data.eduend1
                    this.eduFormData.eduname = data.data.eduname
                    this.eduFormData.majorname = data.data.majorname
                    this.eduFormData.edulevel = data.data.edulevel
                    this.eduFormData.eduimageinfp = data.data.eduimageinfp
                    this.eduFormData.istoday = data.data.istoday

                    this.currentDate = this.convertDateFromString(data.data.edubegin1+'-01')
                    this.currentDate2 = this.convertDateFromString(data.data.eduend1+'-01')                    
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        delImg(index) {
            this.eduFormData.eduimageinfp.splice(index, 1)
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`
            } else if (type === 'month') {
                return `${val}月`
            }
            return val
        },
        dateFormat(fmt, date) {
            let ret
            const opt = {
                'Y+': date.getFullYear().toString(),
                'm+': (date.getMonth() + 1).toString(),
            }
            for (let k in opt) {
                ret = new RegExp('(' + k + ')').exec(fmt)
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
                }
            }
            return fmt
        },
        toggleEdu() {
            this.selectEduPop = true
        },
        onConfirmEdu(value, index) {
            console.log(index)
            if (value === '本科') {
                this.eduFormData.edulevel = 1
            } else if(value === '硕士') {
                this.eduFormData.edulevel = 2
            } else if(value === '博士') {
                this.eduFormData.edulevel = 3
            }
            this.selectEduPop =false
        },
        onCancelEdu() {
            this.selectEduPop =false
        },
        toggleStarTime() {
            this.selectStarTimePop = true
        },
        onConfirmStar(value) {
            var time = this.dateFormat('YYYY-mm', value)
            this.eduFormData.edubegintext = this.dateFormat('YYYY-mm', value)
            this.eduFormData.edubegin = time
            this.eduFormData.edubegin = parseInt(this.eduFormData.edubegin.replace('-',''))
            this.selectStarTimePop = false
        },
        onCancelStar() {
            this.selectStarTimePop = false
        },



        toggleEndTime() {
            this.selectEndTimePop = true
        },
        onConfirmEnd(value) {
            var time = this.dateFormat('YYYY-mm', value)
            this.eduFormData.istoday = false
            this.eduFormData.eduendtext = this.dateFormat('YYYY-mm', value)
            this.eduFormData.eduend = time
            this.eduFormData.eduend = parseInt(this.eduFormData.eduend.replace('-',''))
            this.selectEndTimePop = false
        },
        onCancelEnd() {
            this.selectEndTimePop = false
        },
        saveBtn() {
            if (this.eduFormData.edubegin === '') {
                Toast('请选择就读开始时间')
                return
            }
            if (this.eduFormData.istoday) {
                this.eduFormData.eduend = 0
            }
            if (this.eduFormData.eduend === '') {
                Toast('请选择就读结束时间')
                return
            }
            if (this.eduFormData.eduend > 0) {
                if (parseInt(this.eduFormData.edubegin) > parseInt(this.eduFormData.eduend)) {
                    Toast('就读结束时间必须大于就读开始时间')
                    return
                }
            }
            if (this.eduFormData.eduname === '') {
                Toast('请填写学校名称')
                return
            }
            if (this.eduFormData.majorname === '') {
                Toast('请填写专业名称')
                return
            }
            if (this.eduFormData.edulevel === '') {
                Toast('请选择学历证书')
                return
            }

            this.setLoading(true)
            var params = {
                innerid: this.eduFormData.innerid,
                resumeinnerid: this.eduFormData.resumeinnerid,
                eduname: this.eduFormData.eduname,
                majorname: this.eduFormData.majorname,
                edubegin: this.eduFormData.edubegin,
                eduend: this.eduFormData.eduend,
                edulevel: this.eduFormData.edulevel,
                eduimageinfp: JSON.stringify(this.eduFormData.eduimageinfp)
            }
            if (this.eduFormData.eduimageinfp.length === 0) {
                params.eduimageinfp = ''
            }
            saveOrUpdateEduInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        delBtn() {
            Dialog.confirm({
                message: '确定删除当前教育经历？'
            }).then(() => {
                this.delInfo(this.$route.query.innerid2, 3)
            }).catch(() => {})
        },
        delInfo(id, type) {
            this.setLoading(true)
            var params = {
                objinnerid: id,
                deletetype: type,
            }
            deleteRelatedInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        cancelBtn() {
            this.$router.back()
        },
        eduText(value) {
            if (value === 1) {
                return '本科'
            } else if(value === 2) {
                return '硕士'
            } else if(value === 3) {
                return '博士'
            }
        },
        imgBeforeRead(file) {
            if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
                Toast('请上传 jpg/png/gif 格式图片')
                return false
            }
            let isLt1M = file.size / 1024 / 1024 <= 10
            if (!isLt1M) {
                Toast('图片大小10M以内')
                return false
            }
            return true
        },
        afterRead(file) {
            this._getUploadParam(file.file)
        },
        _getUploadParam(file) {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadImg(file)
                },
                error: data => {
                    this.$toast.fail(data.msg)
                    this.setLoading(false)
                }
            })
        },
        uploadImg (file) {
            this.showImgProBar = true
            const axiosInstance = axios.create({withCredentials: false})
            let formData = new FormData()
            formData.append('file', file)
            formData.append('key', this.uploadSetting.uploadfilekey)
            formData.append('token', this.uploadSetting.uploadauth)
            this.setLoading(true)
            axiosInstance({
                method: 'POST',
                url: this.uploadSetting.uploadurl,
                data: formData,
                timeout: 30000,
            }).then(data => {
                data = JSON.parse(data.request.response)
                this.imgsListFn(Object.assign({}, data, this.fileOtherInfo))
                this.setLoading(false)
            }).catch(data => {
                this.$toast.fail(data.msg)
                this.setLoading(false)
            })
        },
        imgsListFn(file) {
            this.eduFormData.eduimageinfp.push(file)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.EduExperience {
    font-family:PingFangSC-Regular,PingFang SC;
    min-height: 100vh;
    padding-bottom: 2.02rem;
    box-sizing: border-box;
    background-color: #fff;
    .input_box {
        .van-cell__title {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;
            width: 100%;
        }
        .van-cell {
            display: flex;
            flex-direction: column;
            padding: 0.26rem 0.32rem;
            .van-cell__title {
                color: #666;
            }
        }
        .job_time_div {
            display: flex;
            align-items: center;
            &>p:nth-of-type(1) {
                width: 2.92rem;
                text-align: left;
                color: #333;
            }
            &>p:nth-of-type(2) {
                margin: 0 0.2rem;
            }
            &>p:nth-of-type(3) {
                color: #333;
                padding-left: 0.4rem;
                width: 2.84rem;
                text-align: left;
            }
        }
        .edulevel_div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>img {
                width: 0.15rem;
                height: 0.25rem;
            }
        }
        .upload_div {
            display: flex;
            flex-wrap: wrap;
            padding-top: 0.1rem;
            .certificate_img_box {
                margin-right: 0.3rem;
                margin-bottom: 0.3rem;
                position: relative;
                width: 1.46rem;
                height: 1.46rem;
                .del_img {
                    position: absolute;
                    top: -0.1rem;
                    right: -0.1rem;
                    width: 0.3rem;
                    height: 0.3rem;
                }
                .certificate_img {
                    width: 1.46rem;
                    height: 1.46rem;
                    border-radius: 0.16rem;
                }
            }
            .certificate_img_box:nth-of-type(4){
                margin-right: 0;
            }
            .certificate_img_box:nth-of-type(0){
                margin: 0;
            }
            .van-uploader__upload {
                margin: 0;
                width: 1.46rem;
                height: 1.46rem;
            }
        }
    }
    .select_pop_box {
        .van-popup--bottom.van-popup--round {
            border-radius: 0;
        }
    }
    .bottom_btn_box {
        background-color: #fff;
        position: fixed;
        bottom: 0;
        width: 100vw;
        display: flex;
        justify-content: space-between;
        padding: 0 0.32rem;
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        box-sizing: border-box;
        .cancel_btn {
            background-color: #F8F8F8;
            color: #666;
            width: 2.2rem;
            height: 0.82rem;
            line-height: 0.82rem;
            text-align: center;
            font-size: 0.32rem;
        }
        .save_btn {
            background-color: #409EFF;
            color: #FFF;
            width: 4.36rem;
            height: 0.82rem;
            line-height: 0.82rem;
            text-align: center;
            font-size: 0.32rem;
        }
    }
}
</style>